<template>
  <div id="devices">
    <div class="page-title px-4 mb-4">
      <h2>
        <span class="me-2">Device Management</span>
      </h2>
    </div>
    <v-divider class="mt-4 mb-6"></v-divider>

    <v-tabs v-model="activeTab" show-arrows>
      <v-tab href="#list">
        <v-icon class="me-3">{{ icons.mdiTelevision }}</v-icon>
        <span> Device List </span>
      </v-tab>
      <v-tab href="#metrics">
        <v-icon class="me-3">{{ icons.mdiChartLine }}</v-icon>
        <span> Metrics </span>
      </v-tab>
      <v-tab href="#transfers">
        <v-icon class="me-3">{{ icons.mdiSwapHorizontal }}</v-icon>
        <span> Transfers </span>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="activeTab" style="background-color: transparent !important" touchless>
      <v-tab-item value="list">
        <DeviceList />
      </v-tab-item>
      <v-tab-item value="metrics">
        <DeviceMetrics />
      </v-tab-item>
      <v-tab-item value="transfers">
        <Transfers />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mdiChartLine, mdiTelevision, mdiSwapHorizontal } from "@mdi/js"
import DeviceList from "./DeviceList.vue"
import DeviceMetrics from "./DeviceMetrics.vue"
import Transfers from "./Transfers.vue"

const VALID_TABS = ["list", "metrics", "transfers"]
const resolveTab = val => (VALID_TABS.includes(val) ? val : "list")

export default {
  name: "Devices",
  metaInfo: {
    title: "Devices",
  },
  components: {
    DeviceList,
    DeviceMetrics,
    Transfers,
  },
  setup() {
    return {
      icons: {
        mdiChartLine,
        mdiTelevision,
        mdiSwapHorizontal,
      },
    }
  },
  data() {
    return {
      activeTab: resolveTab(this.$route.query.tab),
    }
  },
  watch: {
    activeTab(val) {
      if (this.$route.query.tab === val) return

      this.$router.replace({ query: { ...this.$route.query, tab: val } }).catch(() => {})
    },
    "$route.query.tab": {
      handler(val) {
        const next = resolveTab(val)
        if (this.activeTab !== next) this.activeTab = next
      },
    },
  },
}
</script>
